import React from 'react';
import { styled } from 'styled-components';
const List = (props) => {
    return (React.createElement("div", null, props.items.map((item) => {
        return (React.createElement(ListItem, { key: item.key, onClick: () => {
                props.onSelect(item.returnItem);
            } }, item.label));
    })));
};
export default List;
const ListItem = styled.div `
  padding: 0.5em;
  cursor: pointer;
  border-bottom: 1px solid lightgray;
  font-weight: normal;

  &:hover {
    background: lightgray;
  }
`;
//# sourceMappingURL=List.js.map